import { render } from "./MetricIndex.vue?vue&type=template&id=c40ce380&ts=true"
import script from "./MetricIndex.vue?vue&type=script&lang=ts"
export * from "./MetricIndex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__